var _excluded = ["header", "priceToggle", "image", "main", "aside", "footer", "additionalInfo", "subItems", "bottomContainer"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import useBreakpoint from "../../../hooks/useBreakpoint";
import isNotEmpty from "../../../utils/isNotEmpty";
import FlexContainerOrg from "../FlexContainerOrg";
import PushOrg from "../PushOrg";
import AdditionalInfo from "./AdditionalInfo";
import { Content, HeaderContainer, MainContent, MainContentContainer, PriceToggleWrapper, SubItems } from "./DomainSearchResultBoxOrg.styled";
import SubItem from "./SubItem";
function DomainSearchResultBoxOrg(_ref) {
  var header = _ref.header,
    priceToggle = _ref.priceToggle,
    image = _ref.image,
    main = _ref.main,
    aside = _ref.aside,
    footer = _ref.footer,
    additionalInfo = _ref.additionalInfo,
    subItems = _ref.subItems,
    bottomContainer = _ref.bottomContainer,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var isSmallOnly = useBreakpoint("small", "medium");
  var isMediumUp = useBreakpoint("medium");
  var hasSubItems = !!subItems;
  return /*#__PURE__*/React.createElement("div", restProps, /*#__PURE__*/React.createElement(MainContentContainer, {
    $hasSubItems: hasSubItems
  }, isNotEmpty(priceToggle) ? /*#__PURE__*/React.createElement(PriceToggleWrapper, null, priceToggle) : null, /*#__PURE__*/React.createElement(Content, {
    $hasSubItems: hasSubItems,
    $hasBottomContainer: isNotEmpty(bottomContainer),
    $hasAdditionalInfo: isNotEmpty(additionalInfo)
  }, isNotEmpty(header) ? /*#__PURE__*/React.createElement(HeaderContainer, null, header) : null, /*#__PURE__*/React.createElement(MainContent, null, isMediumUp ? image : null, /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: isSmallOnly ? 2 : undefined
  }, main), aside), isNotEmpty(additionalInfo) ? /*#__PURE__*/React.createElement(AdditionalInfo, {
    main: additionalInfo.main,
    aside: additionalInfo.aside
  }) : null, isNotEmpty(bottomContainer) ? /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: {
      small: 2,
      medium: 3.5,
      large: 3.5
    }
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    justifyContent: "center"
  }, bottomContainer)) : null)), isNotEmpty(subItems) ? /*#__PURE__*/React.createElement(SubItems, null, subItems.map(function (subItem) {
    return /*#__PURE__*/React.createElement(SubItem, {
      key: subItem.key,
      label: subItem.label,
      main: subItem.main,
      aside: subItem.aside
    });
  })) : null, footer);
}
export default DomainSearchResultBoxOrg;